import { createFileRoute } from "@tanstack/react-router";
import { ShiftDetailsPage } from "../../../components/Shifts/ShiftOnePage";


export const Route = createFileRoute("/_layout/shift-entries-list/$shiftId")({
    component: ShiftDetailsPage
});


